import { atom } from "jotai";

export const cargaExitosaAtom = atom(undefined);
export const colaboradoresAtom = atom([]);
export const colaboradoresObservadosAtom = atom([]);
